import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import * as AOS from 'aos';
import { CountryService } from './country.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'SingX';
  isNotificationModalVisible = false;
  sessionStorage;
  localStorage;
  fcmToken = "";

  constructor(private _router: Router, private route: ActivatedRoute, private http: HttpClient, @Inject(DOCUMENT) document,
    private cs: CountryService) {
    this.sessionStorage = document.defaultView.sessionStorage;
    this.localStorage = document.defaultView.localStorage;
  }

  ngOnInit(): void {
    // const np = this.sessionStorage.getItem("denyNotification");
    // const pt = this.localStorage.getItem("pushToken");
    // if (np != "1" && !pt) {
    //   //disabled temporarily
    //   this.isNotificationModalVisible = false;
    // }
    // this.afMessaging.messages
    //   .subscribe((message) => { console.log(message); });

    this.trackProspectSession();

    AOS.init();
    this._router.events.subscribe((event: NavigationEnd) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    })
    this.route.queryParams.subscribe(qP => {
      if (qP['utm_source']) {
        document.cookie = "utm_source=" + qP['utm_source'] + "; path=/singx";
        document.cookie = "utm_source=" + qP['utm_source'] + ";";
        this.localStorage.setItem("utm_source", qP['utm_source']);
      }
      if (qP['utm_campaign']) {
        document.cookie = "utm_campaign=" + qP['utm_campaign'] + "; path=/singx";
        document.cookie = "utm_campaign=" + qP['utm_campaign'] + ";";
        this.localStorage.setItem("utm_campaign", qP['utm_campaign']);
      }
      if (qP['utm_term']) {
        document.cookie = "utm_term=" + qP['utm_term'] + "; path=/singx";
        document.cookie = "utm_term=" + qP['utm_term'] + ";";
        this.localStorage.setItem("utm_term", qP['utm_term']);
      }
      if (qP['utm_medium']) {
        document.cookie = "utm_medium=" + qP['utm_medium'] + "; path=/singx";
        document.cookie = "utm_medium=" + qP['utm_medium'] + ";";
        this.localStorage.setItem("utm_medium", qP['utm_medium']);
      }
      if (qP['utm_content']) {
        document.cookie = "utm_content=" + qP['utm_content'] + "; path=/singx";
        document.cookie = "utm_content=" + qP['utm_content'] + ";";
        this.localStorage.setItem("utm_content", qP['utm_content']);
      }
      // if (qP['country']) {
      //   this.cs.setCountry(qP['country']);
      // } else {
      //   this.cs.setCountry('');
      // }
    })
    //this.trackProspectSession();
  }

  trackProspectSession() {
    const ps = this.sessionStorage.getItem("prospectSession");
    if (ps != "1") {
      const userAgent = window.navigator.userAgent;
      var data = {
        platform: this.cs.getCountry().toUpperCase(),
        deviceInfo: userAgent,
        pushnotificationtoken: this.fcmToken,
        webdeviceId: this.getCookie('_ga')
      };
      this.http.post(environment.apiBase + "/central/landing/prospect", data).subscribe(resp => {
        // save
        this.sessionStorage.setItem("prospectSession", "1");
      }, err => { console.error("Unable to save prospect session"); });
    }
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // requestPermission() {
  //   this.afMessaging.requestPermission
  //     .pipe(mergeMapTo(this.afMessaging.tokenChanges))
  //     .subscribe(
  //       (token) => {
  //         this.sessionStorage.removeItem("prospectSession");
  //         this.fcmToken = token;
  //         this.localStorage.setItem("pushToken", token);
  //         document.cookie = "pushToken=" + token + "; path=/singx";
  //         document.cookie = "pushToken=" + token + ";";
  //         this.trackProspectSession();
  //       },
  //       (error) => {
  //         console.error(error);
  //         this.modal.error({
  //           nzTitle: 'Error',
  //           nzContent: 'There was some error during subsciption'
  //         });
  //       },
  //     );
  // }

  // handleOk(): void {
  //   this.isNotificationModalVisible = false;
  //   this.requestPermission();
  // }

  // handleCancel(): void {
  //   this.sessionStorage.setItem("denyNotification", "1");
  //   this.isNotificationModalVisible = false;
  // }

}
